import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box, Fade, IconButton, Modal } from "@mui/material";
import { CameraAltRounded, CheckRounded, Close, CloseRounded } from "@mui/icons-material";
import Webcam from "react-webcam";
import { dataURLtoFile } from "../../utils";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: 1.4,
    width: '60%',

};

const WebCamera = ({ open, onClose, onSubmit }) => {
    const [image, setImage] = useState(null);
    const webcamRef = useRef(null);

    const url = image ? URL.createObjectURL(image) : null;

    useEffect(() => {
        if (open) setImage(false);
    }, [open])

    const capture = useCallback(() => {
        const imageSrc = webcamRef.current?.getScreenshot();
        setImage(dataURLtoFile(imageSrc));
    }, [webcamRef]);

    const reTake = useCallback(() => {
        setImage(null);
    }, [image]);

    const handleDone = useCallback(() => {
        onSubmit?.([image]);
        onClose();
    }, [image]);

    return (
        <Modal open={open} onClose={onClose}>
            <>
                <div className="absolute right-2 top-1 z-10">
                    <IconButton onClick={onClose} >
                        <Close className="text-4xl text-white" />
                    </IconButton>
                </div>
                <Fade in={open}>
                    <Box className="relative" sx={style}>
                        {url ? (
                            <>
                                <img src={url} className="object-cover w-full h-full" />
                                <div className="flex justify-evenly w-full absolute left-0 bottom-2">
                                    <IconButton onClick={reTake} className="bg-[#2F80ED] text-white p-6">
                                        <CloseRounded className="text-3xl" />
                                    </IconButton>
                                    <IconButton onClick={handleDone} className="bg-[#2F80ED] text-white p-6">
                                        <CheckRounded className="text-3xl" />
                                    </IconButton>
                                </div>
                            </>
                        ) : (
                            <>
                                <Webcam ref={webcamRef} mirrored height={"100%"} width={"100%"} screenshotFormat="image/png" />
                                <div className="flex absolute left-[47%] bottom-2">
                                    <IconButton onClick={capture} className="bg-[#2F80ED] text-white p-6">
                                        <CameraAltRounded className="text-3xl" />
                                    </IconButton>
                                </div>
                            </>
                        )}
                    </Box>
                </Fade>
            </>
        </Modal>
    )
}

export default WebCamera;